<template>
  <div id="evpi" >
    <div style="width: 100%; height: 35px;" ></div>
    <div class="icon" >
      <img src="@/assets/images/Group.png" alt="">
    </div>
    <div class="title" >请完善信息提交申请</div>
    <p>审核成功即可成为协会会员</p>
    <p>（需付费）</p>
    <van-button size="large" class="btn" @click="routerPush()">完善信息</van-button>
    <a size="large" @click="goWebSite()">返回协会官网</a>
    <div class="footer" v-if="false">
      <p>北京冰球运动协会{{validMemberShip.year}}年度协会会员</p>
      <p>有效期至：{{endDate}}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import * as moment from 'moment'
import { getValidMembership } from '@/utils'
import { checkPassport } from '@/libs/passport'
import { getMembership, setMembership } from '@/libs/cookie-storage'
import { getMyMembershipStatus } from '@/api/info'

import { Button, Toast } from 'vant'

Vue.use(Button).use(Toast)
export default {
  name: 'Evpi',
  data () {
    return {
      validMemberShip: {},
      endDate: ''
    }
  },
  created() {
    checkPassport()
    getMyMembershipStatus().then((response) => {
      if (!response) return
      setMembership(response.data)
      const validMemberShip = this.validMemberShip = getValidMembership(response.data)
        if(this.validMemberShip) {
          this.endDate = moment(this.validMemberShip.membershipEndDate).format('YYYY年MM月DD日')
        }
      })
  },
  methods: {
    routerPush() {
      if (this.validMemberShip.playerRegisterEnabled !== 1 &&
        this.validMemberShip.coachRegisterEnabled !== 1 &&
        this.validMemberShip.inRefereeRegisterEnabled !== 1 &&
        this.validMemberShip.outRefereeRegisterEnabled !== 1 &&
        this.validMemberShip.orgRegisterEnabled !== 1) {
        Toast('当前没有可供注册的会员身份，请关注协会开放具体注册时间的通知')
        return
      }
       this.$router.push({ path: 'account-protocol', query: {id: 1} })
       return
    },
    goWebSite() {
      window.location.href = 'http://www.bjhockey.org'
    }
  }
}
</script>

<style scoped>
  #evpi {
    margin: 0 0.3rem;
    /*position: absolute;*/
    /*width: 100%;*/
    /*height: 100%;*/
    background-color: white;
  }

  #evpi .title {
    font-weight:500;
    color:rgba(24,84,148,1);
    font-size: 20px;
    text-align: center;
  }

  #evpi .title+p, #evpi .title+p+p {
    font-size: 14px;
    font-weight:400;
    color:rgba(24,84,148,1);
    line-height:20px;
    margin-top: 0;
    margin-bottom: 0;
    text-align: center;
  }

  #evpi .style-href {
    display: block;
    text-align: center;
    padding-top: 4%;
    font-size: 16px; /*no*/
  }

  #evpi .footer {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%, 0);
    text-align: center;
    width: 100%;
    font-size: 14px; /*no*/
  }

  #evpi .footer p {
    color: #185494;
    line-height: 1.4;
    margin: 0;
    font-size:14px;
    font-weight:400;
  }

  #evpi .icon {
    text-align: center;
    padding-bottom: 10px;
  }

  #evpi .icon img{
    width: 72px;
    height: 60px;
  }

  #evpi .btn {
    margin-top: 70px;
    background:rgba(24,84,148,1);
    border-radius:2px;
    font-size:20px;
    font-weight:400;
    color:rgba(255,255,255,1);
  }

  #evpi .btn+a {
    display: block;
    font-size:18px;
    font-weight:400;
    color:rgba(24,84,148,1);
    text-align: center;
    margin-top: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/evpi.vue